module.exports = __webpack_public_path__ + "3280b19f93d3aa2f9d8bc577fc082661.svg";